var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"elm",class:[
    'CheckVerification',
    `CheckVerification--${_vm.interval}`
  ]})
}
var staticRenderFns = []

export { render, staticRenderFns }